module.exports = __webpack_public_path__ + "img/20190828162047600.ec3c11e6.jpg";